import {breakpointsTailwind, useBreakpoints, useEventListener} from "@vueuse/core";

const breakpoints = useBreakpoints(breakpointsTailwind)

export function useIsMobile() {
  const isMobile = ref(breakpoints.isSmallerOrEqual("sm"))
  const updateIsMobile = () => {
    isMobile.value = breakpoints.isSmallerOrEqual("sm")
  }

  onMounted(() => {
    useEventListener("resize", updateIsMobile)
    updateIsMobile()
  })

  return isMobile
}

